import { Action, createReducer, on } from "@ngrx/store";
import { ClientSidePermissionsActions } from "../actions";
import { clientSidePermissionsAdapter, ClientSidePermissionsState, initialClientSidePermissionsState } from "../states/client-side-permission.states";

export const clientSidePermissionsReducer = createReducer(
  initialClientSidePermissionsState,
  on(
    ClientSidePermissionsActions.clientSidePermissionsSuccess,
    (state, action) => clientSidePermissionsAdapter.setAll(action.permissions, state)
  ),
  on(
    ClientSidePermissionsActions.setUpdatePermSetListing,
    (state, action) => ({ ...state, requiresUpdate: action.update })
  ),
  on(
    ClientSidePermissionsActions.createClientSidePermSuccess,
    (state, action) => ({ ...state, requiresUpdate: true })
  ),
  on(
    ClientSidePermissionsActions.deleteClientSidePermSuccess,
    (state, action) => ({ ...state, requiresUpdate: true })
  ),
  on(
    ClientSidePermissionsActions.updateClientSidePermSuccess,
    (state, action) => ({ ...state, requiresUpdate: true })
  ),
  on(
    ClientSidePermissionsActions.selectClientSidePerm,
    (state, action) => ({ ...state, selectedEntity: action.clientSidePerm })
  ),
)

export function clientSidePermissionsReducers(state: ClientSidePermissionsState | undefined, action: Action) {
  return clientSidePermissionsReducer(state, action)
}
